// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2qKJQ","colMaxWidth":"Table_colMaxWidth__IbjnC"};